import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import CustomButton from './../Forms/CustomButton/CustomButton';
import FormField from './../Forms/FormField/FormField';
import MenuItem from '@material-ui/core/MenuItem';

import './Pagination.scss';

const Pagination = ({totalPage, onChangePage, count, first, last, size }) => {
    const [itemPerpage, setitemPerpage] = useState(25);
    const [currentPage, setCurrentpage] = useState(0);

    useEffect(() => {
        setitemPerpage(25);
        setCurrentpage(0);
    }, [count]);

    const pageChange = ( data, perPage=itemPerpage ) => {
        onChangePage(data.selected+1, perPage);
        setCurrentpage(data.selected);
        window.scrollTo(0, 0);
    }

    const onChangePerPage = (e) => {
        const data = { selected: 0 }
        setitemPerpage(e.target.value);
        pageChange(data, e.target.value);
        window.scrollTo(0, 0);
    }

    const menuItem = [25, 50, 75, 100];

    return(
         <div>
            {count > 25 &&
                <div className='row pad'>
                    <div className='paginate'>              
                        <div className='col-4 col-sm-2 col-md-2 col-lg-3'>
                            <FormField
                                select
                                name='itemPerpage'
                                value={itemPerpage}
                                onChange={e => onChangePerPage(e)}
                            >
                                {menuItem && menuItem.length > 0 && menuItem.map((item) => (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                ))}
                            </FormField>
                        </div>
                        <div className='count'>
                        Total  no. of Records<span className='bold'>{count}</span>
                        </div>
                    </div>
                    <div className='col-12 col-lg'>
                        <ReactPaginate
                            previousLabel={
                                <CustomButton
                                    type='submit'
                                    iconOnly name='previous'
                                    size='large'
                                    iconName='arrow'
                                    disabled={first}
                                />
                            }
                            nextLabel={
                                <CustomButton
                                    type='submit'
                                    iconOnly
                                    name='next'
                                    size='large'
                                    iconName='arrow'
                                    disabled={last}
                                /> 
                            }
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            forcePage={currentPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={2}
                            onPageChange={pageChange}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />                
                    </div>
                </div>
            }            
        </div>
    );    
}

Pagination.propTypes = {   
};

Pagination.defaultProps = {
};

export default Pagination;



// WEBPACK FOOTER //
// ./common/Pagination/Pagination.js